import React, { createContext, useContext, useState } from "react";
import configData from "../data/config.json";
import softwareData from "../data/software.json";
import companyData from "../data/company.json";
import statisticsData from "../data/statistics.json";
import contentData from "../data/content.json";
import pricingData from "../data/pricing.json";
import testimonialsData from "../data/testimonials.json";
import locationsData from "../data/locations.json";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({
    config: configData,
    software: softwareData,
    company: companyData,
    statistics: statisticsData,
    content: contentData,
    pricing: pricingData,
    testimonials: testimonialsData,
    locations: locationsData,
  });

  // Function to update data
  const updateData = (key, newData) => {
    setData((prev) => ({
      ...prev,
      [key]: newData,
    }));
  };

  // Function to reload data (useful after sync)
  const reloadData = async () => {
    try {
      // In production, this could fetch from API
      // For now, we'll reload from JSON files
      const config = await import("../data/config.json");
      const software = await import("../data/software.json");
      const company = await import("../data/company.json");
      const statistics = await import("../data/statistics.json");
      const content = await import("../data/content.json");
      const pricing = await import("../data/pricing.json");
      const testimonials = await import("../data/testimonials.json");
      const locations = await import("../data/locations.json");

      setData({
        config: config.default,
        software: software.default,
        company: company.default,
        statistics: statistics.default,
        content: content.default,
        pricing: pricing.default,
        testimonials: testimonials.default,
        locations: locations.default,
      });
    } catch (error) {
      console.error("Error reloading data:", error);
    }
  };

  return (
    <DataContext.Provider value={{ data, updateData, reloadData }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useData must be used within DataProvider");
  }
  return context;
};
